// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1dwjy","productName":"Table_productName__1RMTn"};